import React, { useContext } from 'react';
import { withI18n } from '@lingui/react';
import { t } from '@lingui/macro';
import Layout from '../src/components/layout/_layout';
import SEO from '~/components/seo';
import PageTypes from '~/page_types';
import Devil from '~/components/pricing/devil';
import FadeInSection from '~/components/fadeinSection';
import HaveAQuestion from '~/components/homepage/haveAQuestion';
import { PricingTable } from '~components/pricing/pricing-table';
import { LangContext } from '~/providers/LangProvider';
import { Country } from "~services/i18n/country";

/**
 * Show pricing for Trisbee Business
 */
function PricingPage() {
    const ctxLang = useContext(LangContext);

    const pageSections = [
        <PricingTable
            country={ctxLang.state.country as Country}
            currency={ctxLang.state.currency}
            language={ctxLang.state.lang}
        />,
        <Devil />,
        <HaveAQuestion whiteBg={true} />,
    ];

    return (
        <Layout
            welcome={false}
            page={PageTypes.PRICING}
        >
            <SEO
                title={t`page.pricing.seo.title`}
                description={t`page.pricing.seo.description`}
            />
            {pageSections.map((section, id) => {
                return <FadeInSection key={id}>{section}</FadeInSection>;
            })}
        </Layout>
    );
}

export default withI18n()(PricingPage);
